import SpeciesRow from "../SpeciesRow";

export default class PlantRow extends SpeciesRow {
    constructor(provider, species, rowContainer) {
        super(provider, species, rowContainer);

        let nextElement;
        rowContainer.elt.childNodes.forEach(n => {
            if (!nextElement) {
                nextElement = n.firstChild.children[1].innerText > species.name + species.scientific_name ? n : null;
            }
        });
        if (nextElement) {
            rowContainer.elt.insertBefore(this.rowDiv.elt, nextElement);
        }
    }

    mouseOver() {
        super.mouseOver();
        this.hoverSet.add(this.speciesCollection.getObjects(this.species.id))
    }

    mouseOut() {
        super.mouseOut();
        this.hoverSet.reset()
    }

    click() {
        if (this.buttonClicked) {
            return;
        }
        this.hoverSet.reset();
        this.tools.setTool('select');
        this.selection.click(this.speciesCollection.getObjects(this.species.id));
    }
}
